import { IAudienceRelevantExperienceQuery } from '../interfaces/audience-relevant-experience.model.interface';
import { RelevantExperience } from './relevant-experience.model';

// @dynamic
export class AudienceRelevantExperience {
    experience: RelevantExperience;
    status: number;

    constructor(query?: IAudienceRelevantExperienceQuery) {
        if (query) {
            this.experience = query.experience ? new RelevantExperience(query.experience) : null;
            this.status = query.status;
        }
    }
}
